/**
 * Init input effects and js-animations
 */
export default function initMenuHandling() {
    document.addEventListener('click', function (event) {
        let target = event.target;

        /**
         * Main menu
         */
        let mainMenuContainer = document.getElementById('main-menu');

        if (mainMenuContainer) {
            // Open / close main menu
            if (
                target.id === 'main-menu' ||
                target.classList.contains('box-main-menu')
            ) {
                mainMenuContainer.classList.toggle('menu-open');
            }

            // Close main menu if click is outside
            if (!mainMenuContainer.contains(event.target)) {
                mainMenuContainer.classList.remove('menu-open');
            }
        }

        /**
         * User menu
         */
        let userMenuContainer = document.getElementById('navbar-user-menu');

        // Open / close user menu
        if (userMenuContainer) {
            if (target.id === 'navbar-user-menu-toggle') {
                userMenuContainer.classList.toggle('menu-open');
            }

            // Close user menu if click is outside
            if (!userMenuContainer.contains(event.target)) {
                userMenuContainer.classList.remove('menu-open');
            }
        }
    });
}
